export default () => {
  return {
    initial: {
      query: '',
      category_ids: [],
    },
    configuration: {
      query: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'accounts_marketplace::categories_list.filters.input.label',
        placeholder:
          'accounts_marketplace::categories_list.filters.input.label',
        order: 1,
        type: 'input',
      },
      category_ids: {
        subbutton: {
          isVisible: (value = [], breakpoints) =>
            value.length > 0 || !breakpoints.fb,
        },
        label:
          'accounts_marketplace::categories_list.filters.dropdown.items.category_ids.label',
        position: 'dropdown',
        type: 'checkbox group',
        optionLabelPrefix: '',
        options: [],
      },
    },
  }
}
